import styled from "styled-components";

export const STitleWithTooltip = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  user-select: none;
`;
